export default __webpack_public_path__ + "images/2435f2ff3571ee8bc8b1225c92d7c54c.webp";